module.exports = __webpack_public_path__ + "img/money.91efbba0.svg";